import { setCookie } from '@app/javascript/classes/cookies'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  inboxSettingsReset() {
    setCookie(`${this.inboxSettingsCookiePrefix}.is_read`, '', this.cookieParams)
    setCookie(`${this.inboxSettingsCookiePrefix}.is_irrelevant`, '', this.cookieParams)
    setCookie(`${this.inboxSettingsCookiePrefix}.is_watchlisted`, '', this.cookieParams)
  }

  inboxSettingsToggledByUser(event) {
    setCookie(
      `${this.inboxSettingsCookiePrefix}.${event.target.name}`,
      event.target.value,
      this.cookieParams
    )
  }

  get inboxSettingsCookiePrefix() {
    return 'searchPage.inboxSettings'
  }

  get cookieParams() {
    return { longLasting: true, path: '/' }
  }
}
